<div class="header">
    <h2>Contacts List</h2>
  </div>
  <mat-card>
    <button mat-flat-button color="primary" [routerLink]="['/notifications', 'contacts','create-contact']"
      routerLinkActive="router-link-active">
      <mat-icon>add</mat-icon>
      Create Contact
    </button>
    <div class="table-container mat-elevation-z0">
      <table mat-table [dataSource]="contactsList?.results" matTableResponsive>
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef class="small-cell">
            No.
          </th>
          <td mat-cell *matCellDef="let i=index" class="small-cell">
            {{i+1 +pageOffset}}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            Name
          </th>
          <td mat-cell *matCellDef="let record">
            {{record.name || '-'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>
              Email
            </th>
            <td mat-cell *matCellDef="let record">
              {{record.email || '-'}}
            </td>
          </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            Action
          </th>
          <td mat-cell *matCellDef="let record">
            <button mat-stroked-button color="primary" [routerLink]="['/notifications', 'contacts','edit',record.id]"
              routerLinkActive="router-link-active">Edit</button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <mat-paginator [length]="contactsList?.count" (page)="onPaginationChange($event)" [pageIndex]="pageIndex"
      [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
  </mat-card>
  
